import {useCallback, ReactNode} from 'react';

import {defineMessages, FormattedMessage, MessageDescriptor} from 'react-intl';

import {css, Icon, Action, Tooltip, createView} from '@sail/ui';
import {cancel} from '@sail/icons/react/Icon';

import {useAnalytics} from '../AnalyticsProvider';
import {AssistantHeader} from './AssistantHeader';

const messages = defineMessages({
  closeTooltip: {
    id: 'conversations_ui.header.closeTooltip',
    description: 'Label for the close botton',
    defaultMessage: 'Close',
  },
});

const buttonStyles = css({
  display: 'inline-flex',
  borderRadius: 'rounded',
  padding: 'small',
  ':hover': {
    backgroundColor: 'offset',
  },
});

type Props = {
  title?: MessageDescriptor;
  height?: number | string;
  badge?: ReactNode;
  onClose: () => void;
  headerActions?: ReactNode;
  subHeader?: ReactNode;
};

export const AssistantDrawerHeader = createView(
  ({
    title,
    height = 52,
    badge,
    onClose,
    headerActions,
    subHeader,
    ...props
  }: Props) => {
    const analytics = useAnalytics();

    const handleClose = useCallback(() => {
      onClose();
      analytics.action('stripe_assistant_header_close_click');
    }, [analytics, onClose]);

    const allHeaderActions = (
      <>
        {headerActions}
        <Tooltip
          type="label"
          delay={600}
          trigger={
            <Action
              data-testid="conversations-drawer-header-close-button"
              onPress={handleClose}
              uses={[buttonStyles]}
            >
              <Icon icon={cancel} size="xsmall" />
            </Action>
          }
        >
          <FormattedMessage {...messages.closeTooltip} />
        </Tooltip>
      </>
    );

    return (
      <AssistantHeader
        title={title}
        height={height}
        badge={badge}
        headerActions={allHeaderActions}
        subHeader={subHeader}
        {...props}
      />
    );
  },
);
